export default __webpack_public_path__ + "images/2a7ca844268fe5d43a5431512a85f583-bandsintown_logo.svg";